/**
 * Simple and direct DOM portal implementation for Vue 2
 * This moves DOM elements directly to avoid issues with event handlers
 */

const DirectPortal = {
  install(Vue) {
    // Add a global directive for portal functionality
    Vue.directive('portal', {
      // eslint-disable-next-line no-unused-vars
      inserted(el, binding, vnode) {
        // Get the target element
        const target = document.querySelector(binding.value) || document.body;
        
        // Store the original parent for later
        el._originalParent = el.parentNode;
        el._placeholder = document.createComment('portal-placeholder');
        
        // Replace element with placeholder
        if (el.parentNode) {
          el.parentNode.replaceChild(el._placeholder, el);
        }
        
        // Add some extra classes to help with styling
        el.classList.add('vue-direct-portal-content');
        
        // Move the element to the target
        target.appendChild(el);
      },
      
      unbind(el) {
        // Clean up when directive is removed
        if (el._originalParent && el._placeholder && el._placeholder.parentNode) {
          // Restore the element to its original position
          el._placeholder.parentNode.replaceChild(el, el._placeholder);
          
          // Remove added classes
          el.classList.remove('vue-direct-portal-content');
        } else if (el.parentNode) {
          // Just remove it if we can't restore properly
          el.parentNode.removeChild(el);
        }
      }
    });
  }
};

export default DirectPortal;
